import * as cryptoJS from 'crypto-js';
import { CRYPTO_JS } from '../constants/cryptoJs';

const options = {
    iv: cryptoJS.enc.Utf8.parse(CRYPTO_JS.aesIV),
    padding: cryptoJS.pad.Pkcs7,
    mode: cryptoJS.mode.CBC,
    algorithm: cryptoJS.algo.AES,
    blockSize: CRYPTO_JS.aesBlockSize,
};

export const encryptAES = (text: string) => {
    let key = cryptoJS.enc.Utf8.parse(CRYPTO_JS.aesSecret);
    const encrypted = cryptoJS.AES.encrypt(
        cryptoJS.enc.Utf8.parse(text),
        key,
        options
    );
    return encrypted.toString();
};

export const decryptAES = (textEncrypted: string) => {
    let key = cryptoJS.enc.Utf8.parse(CRYPTO_JS.aesSecret);
    const decrypted = cryptoJS.AES.decrypt(textEncrypted, key, options);
    return decrypted.toString(cryptoJS.enc.Utf8);
};
